export const CLIENT_SIDE_BOT_DETECTION_SCHEMA =
  'iglu:com.snowplowanalytics.snowplow/client_side_bot_detection/jsonschema/1-0-0';
